import useTranslation from '../../../../hooks/useTranslation';
import Icon from '../../../../components/Icon';

function Footer() {
  const { t } = useTranslation();
  return (
    <p className="clearfix mb-0">
      <span className="float-md-start d-block d-md-inline-block mt-25" />
      <span className="float-md-end d-none d-md-block">
        {t('Made with')}
        <Icon
          icon="fa-heart"
        />
      </span>
    </p>
  );
}

export default Footer;
